// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import purchaseSupplierEntity from './entities/purchase-supplier.json';
import purchaseSupplierMenu from '../pages/purchase-supplier/menu.json';
import purchaseSupplierFullForm from '../pages/purchase-supplier/forms/full.json';
import purchaseSupplierContextForm from '../pages/purchase-supplier/forms/context.json';
import purchaseSupplierMiniForm from '../pages/purchase-supplier/forms/mini.json';
import purchaseSupplierLookupForm from '../pages/purchase-supplier/forms/lookup.json';
import purchaseSupplierTableView from '../pages/purchase-supplier/views/table.json';
import purchaseSupplierCardsView from '../pages/purchase-supplier/views/cards.json';
import purchaseSupplierDashboardView from '../pages/purchase-supplier/views/dashboard.json';

/** Тип запису «Постачальник» зі сторінками пакета: меню, форми та подання з pages/purchase-supplier/. */
export const purchaseSupplierDefinition: IRecordTypeDefinition = {
  ...purchaseSupplierEntity,
  views: assembleViewSet({
      table: purchaseSupplierTableView,
      cards: purchaseSupplierCardsView,
      dashboard: purchaseSupplierDashboardView,
  }),
  form: purchaseSupplierFullForm,
  forms: { full: purchaseSupplierFullForm, context: purchaseSupplierContextForm, mini: purchaseSupplierMiniForm, lookup: purchaseSupplierLookupForm },
  menu: purchaseSupplierMenu,
} as IRecordTypeDefinition;
